"use client";

import { AddHostButton } from "./HostPageActions";
import { HostsList } from "./components";
import { useEventContextV2, usePermissionsContext } from "~/app/providers";

export default function EventGuestsPage() {
    const event = useEventContextV2();
    const permissions = usePermissionsContext();

    const canDeleteHost =
        permissions.isHost || permissions.isAdmin || permissions.isManager;

    return (
        <section>
            <div className="flex flex-col gap-5 rounded-md bg-v3-N-600 p-6">
                <div className="flex items-center gap-4">
                    <h2 className="text-base text-v3-N-300">Hosts</h2>
                    <AddHostButton
                        eventId={event.id}
                        communityId={event.communityId}
                    />
                </div>

                <HostsList
                    hosts={event.hosts}
                    preapprovals={event.hostPreapprovals}
                    event={event}
                    canDelete={canDeleteHost || false}
                />
            </div>
        </section>
    );
}
